module.exports = __webpack_public_path__ + "static/media/sot.147c3d62.png";